

















































import {
  defineComponent
} from '@nuxtjs/composition-api';
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";
import {useUrl} from "~/composables/Palmers";
import Slider from "~/components/Palmers/BaseComponents/Slider/Slider.vue";
import SliderItem from "~/components/Palmers/BaseComponents/Slider/SliderItem.vue";

export default defineComponent({
  name: 'ElementAmbassadors',
  components: {
    PictureItem,
    Slider,
    SliderItem
  },
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  setup() {
    const {getMediaUrl} = useUrl();

    return {
      getMediaUrl
    }
  }
});
